import { render, staticRenderFns } from "./BwTableComponent.vue?vue&type=template&id=a6004f44"
import script from "./BwTableComponent.vue?vue&type=script&lang=js"
export * from "./BwTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports